import DetailPage from "../components/DetailPage";
import { detailPages } from "../data/detailPages";

export default function TraceabilityPredictability() {
  return <DetailPage data={detailPages["traceability-predictability"]} />;
}
